import styled from 'styled-components';

const StyledAppHeader = styled.div`
    header.ant-layout-header {
        position: relative;
        z-index: 10;
        max-width: 100%;
        background: #ffffff;
        -webkit-box-shadow: 0 2px 8px #f0f1f2;
        box-shadow: 0 2px 8px #f0f1f2;
        padding: 0 25px;
    }
`;

export default StyledAppHeader;
